import { __ } from '@wordpress/i18n';
import { SimpleCheckbox } from '@getdokan/dokan-ui';

const ApplyForRoles = ( { allRoles, rule, handleRoleChange } ) => {
    return (
        <div className="bg-white rounded-lg shadow mb-5">
            <div className="p-5 border-b border-[#E9E9E9]">
                <h2 className="text-lg font-bold text-[#25252D]">
                    { __( 'Apply quote for', 'dokan' ) }
                </h2>
            </div>
            <div className="max-h-96 overflow-y-auto space-y-3 p-5">
                { allRoles &&
                    Object.entries( allRoles ).map(
                        ( [ key, name ] ) => (
                            <div
                                key={ key }
                                className="flex items-center"
                            >
                                <label className="inline-flex items-center gap-1 py-1">
                                    <SimpleCheckbox
                                        className="m-0 focus:ring-0 w-[18px] h-[18px]"
                                        checked={ rule.selected_user_role.includes(
                                            key
                                        ) }
                                        onChange={ () =>
                                            handleRoleChange( key )
                                        }
                                        input={ {} }
                                    />
                                    <span className="text-sm text-[#575757]">
                                        { name as string }
                                    </span>
                                </label>
                            </div>
                        )
                    ) }
            </div>
        </div>
    );
};

export default ApplyForRoles;
